import projectIdToTemplate from './projectIdToTemplate'
import TextMessage from "@/components/FilterForms/TextMessage";
import CheckBoxes from "@/components/FilterForms/CheckBoxes";
import DateRanger from "@/components/FilterForms/DateRanger";
import DateUtil from 'vue2-daterange-picker/src/components/date_util/native'

const projectIdToName = {};
const allProjectIds = [];

for (let projectId in projectIdToTemplate) {
    if (projectIdToTemplate.hasOwnProperty(projectId)) {
        projectIdToName[projectId] = projectIdToTemplate[projectId]['project_name']
        allProjectIds.push(projectId);
    }
}

const allProjectOptions = Object.keys(projectIdToName).sort((a, b) => (parseInt(a) < parseInt(b) ? -1 : 1)).map(v => ({
    value: v,
    label: projectIdToName[v]
}));

const documentStatusIdToLabel = {
    '1': 'Todo',
    '2': 'Done',
    '3': 'Skipped'
};

const statusIds = {
    todo: '1',
    done: '2',
    skipped: '3',
};

const currencyIdToLabel = {};

const currencyOptions = [];

const currencyMaps = {
    "USD": {
        "symbol": ["US$", "U.S.$"],
        "name": "US Dollar"
    },
    "CNY": {
        "symbol": ["CN¥", "RMB"],
        "name": "Chinese Yuan/Ren Min Bi"
    },
    "HKD": {
        "symbol": "HK$",
        "name": "Hong Kong Dollar"
    },
    "EUR": {
        "symbol": "€",
        "name": "Euro"
    },
    "GBP": {
        "symbol": "£",
        "name": "British Pound Sterling"
    },
    "AUD": {
        "symbol": "AU$",
        "name": "Australian Dollar"
    },
    "CAD": {
        "symbol": "CA$",
        "name": "Canadian Dollar"
    },
    "IDR": {
        "symbol": "Rp",
        "name": "Indonesian Rupiah"
    },
    "INR": {
        "symbol": "Rs",
        "name": "Indian Rupee"
    },
    "JPY": {
        "symbol": "¥",
        "name": "Japanese Yen"
    },
    "KRW": {
        "symbol": "₩",
        "name": "South Korean Won"
    },
    "KZT": {
        "symbol": "₸",
        "name": "Kazakhstani Tenge"
    },
    "MOP": {
        "symbol": "MOP$",
        "name": "Macanese Pataca"
    },
    "MXN": {
        "symbol": "MX$",
        "name": "Mexican Peso"
    },
    "MYR": {
        "symbol": "RM",
        "name": "Malaysian Ringgit"
    },
    "NOK": {
        "symbol": "Nkr",
        "name": "Norwegian Krone"
    },
    "NZD": {
        "symbol": "NZ$",
        "name": "New Zealand Dollar"
    },
    "RUB": {
        "symbol": "RUB",
        "name": "Russian Ruble"
    },
    "SEK": {
        "symbol": "Skr",
        "name": "Swedish Krona"
    },
    "SGD": {
        "symbol": "S$",
        "name": "Singapore Dollar"
    },
    "THB": {
        "symbol": "฿",
        "name": "Thai Baht"
    },
    "TRY": {
        "symbol": "TL",
        "name": "Turkish Lira"
    },
    "TWD": {
        "symbol": "NT$",
        "name": "New Taiwan Dollar"
    },
    "ZAR": {
        "symbol": "R",
        "name": "South African Rand"
    }

};

for (let currencyId in currencyMaps) {
    if (currencyMaps.hasOwnProperty(currencyId)) {
        currencyIdToLabel[currencyId] = currencyId;
        currencyOptions.push({
            value: currencyId,
            label: currencyId,
        });
    }
}

const documentStatusOptions = ['1', '2', '3'].map(v => {
    return {value: v, label: documentStatusIdToLabel[v]}
});

const timePeriodOptions = ['Year', 'Month', 'Week', 'Day'].map(value => ({value, label: value}))

const additionalDocumentProperties = function (enableSerial) {
    let properties = [];
    if (enableSerial) {
        properties.push({
            label: 'Nature',
            customDataKey: 'nature',
            renderer(item) {
                const nature = item['custom_data'][this.customDataKey];
                const text = nature || '';
                return `<span class="doc-nature mx-2">${text}</span>`;
            },
            renderHTML: true,
            className: 'text-left',
            sortable: {
                asc: {'custom_data.nature': 1},
                desc: {'custom_data.nature': -1},
            },
            filterable: {
                pipsBuilder(payload) {
                    const map = {
                        commence: {
                            'custom_data.nature': 'Commence'
                        },
                        result: {
                            'custom_data.nature': 'Result'
                        },
                        empty: {
                            'custom_data.nature': null,
                        }
                    };
                    let $or = payload.selectedItems.map(v => (map[v]));
                    return [
                        {
                            $match: {
                                $or
                            }
                        }
                    ]
                },
                labelRenderer(payload) {
                    const map = {
                        commence: 'Commence',
                        result: 'Result',
                        empty: '(Empty)'
                    };
                    return `<span>${payload.selectedItems.map(v => (map[v])).join(', ')}</span>`;
                },
                filterForm: CheckBoxes,
                parameters: {
                    items: [
                        {
                            label: 'Commence',
                            id: 'commence',
                        },
                        {
                            label: 'Result',
                            id: 'result',
                        },
                        {
                            label: '(Empty)',
                            id: 'empty'
                        }
                    ]
                }
            },
        })
    }
    return properties.concat([
        {
            label: 'Stock Code',
            customDataKey: 'stock_code',
            renderer(item) {
                return item['custom_data'][this.customDataKey]
            },
            className: 'text-center',
            sortable: {
                asc: {'custom_data.stock_code': 1},
                desc: {'custom_data.stock_code': -1},
            },
            filterable: {
                pipsBuilder(payload) {
                    return [{$match: {'custom_data.stock_code': payload.value}}]
                },
                labelRenderer(payload) {
                    return `<span>${payload.value}</span>`;
                },
                filterForm: TextMessage,
            }
        },
        {
            label: 'Document Issuer',
            customDataKey: 'gekko_id_company',
            renderer(item) {
                return item['custom_data'][this.customDataKey]
            },
            className: 'text-center',
            sortable: {
                asc: {'custom_data.gekko_id_company': 1},
                desc: {'custom_data.gekko_id_company': -1},
            },
            filterable: {
                pipsBuilder(payload) {
                    let id = parseInt(payload.value);
                    if (isNaN(id)) {
                        return [{$match: {'custom_data.gekko_id_company': payload.value}}]
                    } else {
                        return [{$match: {'custom_data.gekko_id_company': id}}]
                    }
                },
                labelRenderer(payload) {
                    return `<span>${payload.value}</span>`;
                },
                filterForm: TextMessage,
            }
        },
        {
            label: 'Release Date',
            customDataKey: 'release_date',
            renderer(item) {
                return item['custom_data'][this.customDataKey].substr(0, 10)
            },
            className: 'text-center',
            sortable: {
                asc: {'custom_data.release_date': 1},
                desc: {'custom_data.release_date': -1},
            },
            sortedDefault: {
                direction: 'desc',
            },
            filterable: {
                // eslint-disable-next-line no-unused-vars
                pipsBuilder(payload) {
                    let {startDate, endDate} = payload.range;
                    const $and = [];
                    if (startDate) {
                        $and.push({
                            'custom_data.release_date': {
                                $gte: DateUtil.format(startDate, 'yyyy-mm-dd')
                            }
                        })
                    }
                    if (endDate) {
                        $and.push({
                            'custom_data.release_date': {
                                $lte: DateUtil.format(endDate, 'yyyy-mm-dd 23:59')
                            }
                        })
                    }
                    return [{$match: {$and}}]
                },
                labelRenderer(payload) {
                    let {startDate, endDate} = payload.range;
                    if (startDate) {
                        startDate = DateUtil.format(startDate, 'yyyy-mm-dd')
                    } else {
                        startDate = '';
                    }
                    if (endDate) {
                        endDate = DateUtil.format(endDate, 'yyyy-mm-dd')
                    } else {
                        endDate = '';
                    }
                    return `<span>${startDate} - ${endDate}</span>`;
                },
                filterForm: DateRanger,
            },
        },
        {
            label: 'Headline Categories',
            customDataKey: 'subtypes_original',
            renderer(item) {
                const items = item['custom_data'][this.customDataKey];
                if (items && items.length) {
                    // line > container > headline + others
                    const line = document.createElement('div');
                    line.className = 'line';
                    line.title = items.join('\n');
                    const container = document.createElement('span');
                    line.appendChild(container);
                    const headline = document.createElement('span');
                    let firstHeadline = items[0];
                    if (firstHeadline.length > 27) {
                        firstHeadline = firstHeadline.substr(0, 27) + '...';
                    }
                    headline.innerText = firstHeadline;
                    container.appendChild(headline);

                    if (items.length > 1) {
                        const others = document.createElement('span');
                        others.className = 'text-gray';
                        others.innerText = ` and ${items.length - 1} others`;
                        container.appendChild(others);
                    }
                    return line.outerHTML;
                }
                return '';
            },
            renderHTML: true,
            exportValue(item) {
                const items = item['custom_data'][this.customDataKey];
                if (items && items.length) {
                    return items.join('\n');
                }
                return '';
            }
        }
    ])
};

const additionalDocumentPropertiesInDocInfo = [
    {
        label: 'Nature',
        customDataKey: 'nature',
        renderer(item) {
            const nature = item['custom_data'][this.customDataKey];
            return nature || '';
        },
    },
    {
        label: 'Stock Code',
        customDataKey: 'stock_code',
        renderer(item) {
            return item['custom_data'][this.customDataKey]
        }
    },
    {
        label: 'Release Date',
        customDataKey: 'release_date',
        renderer(item) {
            return item['custom_data'][this.customDataKey].substr(0, 10)
        }
    },
    {
        label: 'Headline Categories (Scoped)',
        customDataKey: 'subtypes_selected',
        renderer(item) {
            return item['custom_data'][this.customDataKey].join(', ')
        }
    },
    {
        label: 'Headline Categories (Full)',
        customDataKey: 'subtypes_original',
        renderer(item) {
            return item['custom_data'][this.customDataKey].join(', ')
        }
    },
    {
        label: 'Document Type',
        customDataKey: 'maintype',
        renderer(item) {
            return item['custom_data'][this.customDataKey]
        }
    },
    {
        label: 'Title',
        customDataKey: 'title',
        renderer(item) {
            return item['custom_data'][this.customDataKey]
        }
    },
    {
        label: 'Document Issuer',
        customDataKey: 'gekko_id_company',
        renderer(item) {
            return item['custom_data'][this.customDataKey]
        }
    },
];

const documentSourceKey2Label = {
    'en': 'English',
    'ch': 'Chinese'
};

const documentSourceKeys = ['en', 'ch'];

const itemValueProperty = 'entityId';

const statusHTMLRenderer = function (status) {
    let colorClass;
    let iconClass;
    switch (status) {
        case statusIds.done:
            colorClass = 'text-home-done';
            iconClass = 'gf-success';
            break;
        case statusIds.skipped:
            colorClass = 'text-home-skipped';
            iconClass = 'gf-skipped';
            break;
        case statusIds.todo:
            colorClass = 'text-home-todo';
            iconClass = 'gf-todo';
            break;
    }
    return `<span class="${colorClass} status-icon"><i class="gf ${iconClass}"></i></span>`;
}

export {
    allProjectOptions,
    documentStatusOptions,
    additionalDocumentProperties,
    projectIdToTemplate,
    documentStatusIdToLabel,
    projectIdToName,
    documentSourceKey2Label,
    documentSourceKeys,
    currencyOptions,
    currencyIdToLabel,
    additionalDocumentPropertiesInDocInfo,
    statusIds,
    itemValueProperty,
    statusHTMLRenderer,
    currencyMaps,
    allProjectIds,
    timePeriodOptions,
}
